// 导出 excel
export const exportExcel = (res) => {
  //console.log(res.headers)
  let filename = decodeURI(res.headers['content-disposition']?.split('filename=')[1]);
  let blob = new Blob([res.data], {
    type: 'application/vnd.ms-excel;charset=utf-8'
  })
  if (window.navigator.msSaveBlob) {
    console.log('msSaveBlob')
    try {
      window.navigator.msSaveBlob(blob, filename)
    } catch (e) {
      console.log(e)
    }
  } else {
    let downloadElement = document.createElement('a');
    let href = window.URL.createObjectURL(blob); //创建下载的链接
    downloadElement.href = href;
    downloadElement.download = filename; //下载后文件名
    document.body.appendChild(downloadElement);
    downloadElement.click(); //点击下载
    document.body.removeChild(downloadElement); //下载完成移除元素
    window.URL.revokeObjectURL(href); //释放掉blob对象
  }
}


// 导出 图片
export const eChartsExportImg = (chart, title = "图片") => {
  var url = chart.getConnectedDataURL({
    pixelRatio: 2, //导出的图片分辨率比率,默认是1
    backgroundColor: '#fff', //图表背景色
    excludeComponents: [
      //保存图表时忽略的工具组件,默认忽略工具栏
      'toolbox',
    ],
    type: 'png', //图片类型支持png和jpeg
  })
  if (window.navigator.msSaveOrOpenBlob) {
    // 截取base64的数据内容（去掉前面的描述信息，类似这样的一段：data:image/png;base64,）并解码为2进制数据
    let bstr = atob(url.split(',')[1])
    // 获取解码后的二进制数据的长度，用于后面创建二进制数据容器
    let n = bstr.length
    // 创建一个Uint8Array类型的数组以存放二进制数据
    let u8arr = new Uint8Array(n)
    // 将二进制数据存入Uint8Array类型的数组中
    while (n--) {
    u8arr[n] = bstr.charCodeAt(n)
    }
    // 创建blob对象
    let blob = new Blob([u8arr])
    // 调用浏览器的方法，调起IE的下载流程
    window.navigator.msSaveOrOpenBlob(blob, title + '.jpg')
    return
}

  var $a = document.createElement('a');
  var type = 'png';
  $a.download = title + '.' + type;
  $a.target = '_blank';
  $a.href = url;
  // Chrome and Firefox
  if (typeof MouseEvent === 'function') {
    var evt = new MouseEvent('click', {
      view: window,
      bubbles: true,
      cancelable: false
    });
    $a.dispatchEvent(evt);
  }
  // 这里兼容ie没有兼容到
  // else {
  //   var html = ''
  //   '<body style="margin:0;">'
  //   '![](' + url + ')'
  //   '</body>';
  //   console.log()
  //   var tab = window.open();
  //   tab.document.write(html);
  // }
}
